import { useMemo } from 'react';

import type { ReadyToSharePosts } from '#src/app/shared/api/readyToShare';
import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

import { useGetDashboardShareContent } from './useGetDashboardShareContent';
import { useGetDashboardShareTrackingData } from './useGetDashboardShareTrackingData';
import { useGetDashboardShareUrl } from './useGetPetitionShareUrl';
import { useOnDashboardShareSuccess } from './useOnDashboardShareSuccess';

export function useDashboardShareOptions(
	previewLinkConfigs?: ReadyToSharePosts['items'],
	customTrackingData?: Array<Record<string, string>>,
	customUtmParams?: Array<Record<string, string>>,
): ShareActionsOptions<ShareChannel> {
	const getUrl = useGetDashboardShareUrl(previewLinkConfigs, customUtmParams);
	const getContent = useGetDashboardShareContent();
	const getTrackingData = useGetDashboardShareTrackingData(customTrackingData);
	const onSuccess = useOnDashboardShareSuccess();

	return useMemo(
		() => ({
			trackingEventName: 'share_petition',
			getUrl,
			getContent,
			getTrackingData,
			onSuccess,
		}),
		[getUrl, getContent, getTrackingData, onSuccess],
	);
}
